var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiSubmit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 5.95996C0.75 3.47468 2.76472 1.45996 5.25 1.45996H18.75C21.2353 1.45996 23.25 3.47468 23.25 5.95996V16.46C23.25 18.9452 21.2353 20.96 18.75 20.96H14.9653L12.5644 23.7038C12.422 23.8666 12.2163 23.96 12 23.96C11.7837 23.96 11.578 23.8666 11.4356 23.7038L9.03469 20.96H5.25C2.76472 20.96 0.75 18.9452 0.75 16.46V5.95996ZM5.25 2.95996C3.59314 2.95996 2.25 4.30311 2.25 5.95996V16.46C2.25 18.1168 3.59314 19.46 5.25 19.46H9.375C9.59126 19.46 9.79702 19.5533 9.93945 19.7161L12 22.071L14.0606 19.7161C14.203 19.5533 14.4087 19.46 14.625 19.46H18.75C20.4069 19.46 21.75 18.1168 21.75 16.46V5.95996C21.75 4.30311 20.4069 2.95996 18.75 2.95996H5.25ZM12 5.95996C12.3501 5.95996 12.6537 6.20225 12.7313 6.54365L13.1463 8.36855C13.3382 9.21264 13.9973 9.87174 14.8414 10.0637L16.6663 10.4786C17.0077 10.5563 17.25 10.8598 17.25 11.21C17.25 11.5601 17.0077 11.8637 16.6663 11.9413L14.8414 12.3563C13.9973 12.5482 13.3382 13.2073 13.1463 14.0514L12.7313 15.8763C12.6537 16.2177 12.3501 16.46 12 16.46C11.6499 16.46 11.3463 16.2177 11.2687 15.8763L10.8537 14.0514C10.6618 13.2073 10.0027 12.5482 9.15859 12.3563L7.33369 11.9413C6.99229 11.8637 6.75 11.5601 6.75 11.21C6.75 10.8598 6.99229 10.5563 7.33369 10.4786L9.15859 10.0637C10.0027 9.87174 10.6618 9.21264 10.8537 8.36855L11.2687 6.54365C11.3463 6.20225 11.6499 5.95996 12 5.95996ZM12 9.57436C11.641 10.2778 11.0678 10.851 10.3644 11.21C11.0678 11.5689 11.641 12.1421 12 12.8456C12.359 12.1421 12.9322 11.5689 13.6356 11.21C12.9322 10.851 12.359 10.2778 12 9.57436Z",
    fill: "url(#paint0_linear_71_8639)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_71_8639",
    x1: 0.75,
    y1: 12.71,
    x2: 23.25,
    y2: 12.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5A24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#613DC1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiSubmit);
export default __webpack_public_path__ + "static/media/AISubmit.047a4263daa2b15e8a30798601881372.svg";
export { ForwardRef as ReactComponent };